export default __webpack_public_path__ + "static/media/icon_profile.67b5393b.svg";